export const FETCH_USAGE_DATA_REQUEST = 'FETCH_USAGE_DATA_REQUEST';
export const FETCH_USAGE_DATA_SUCCESS = 'FETCH_USAGE_DATA_SUCCESS';
export const FETCH_USAGE_DATA_ERROR = 'FETCH_USAGE_DATA_ERROR';
